import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import Select from 'react-select'
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { Field, Formik } from "formik";

function ComponentNewSpecilidad({t, showModal, setShowModal, specialityOpt, handleClose, setSpecialtyDurationList, 
    specialtyDurationList, initEspecialidad, indexEdit,currenciesOpt, planesOpt, hasCopaymentParent}){
    const [existeEspecialidad, setExisteEspecialidad] = useState(false)
    const [specialityDef, setSpecialityDef] = useState(null)
    const [initialValues, setInitialValues] = useState(
        {
            id: null,
            especialty:'',
            duration:'',
            firstWait: '',
            secondWait:'',
            hasCopayment: false,
            amountPayment: '',
            currency: {
                id: ''
            },
            plan: {
                id: ''
            }
        }
    )
    useEffect(() => {
        if(initEspecialidad!==null){
            setInitialValues({
                id: initEspecialidad.id,
                especialty:initEspecialidad.especialty.id,
                duration:initEspecialidad.duration,
                firstWait: initEspecialidad.firstWait,
                secondWait:initEspecialidad.secondWait,
                hasCopayment: initEspecialidad.hasCopayment,
                amountPayment: initEspecialidad.amountPayment ?? '',
                currency: {
                    id: initEspecialidad.currency?.id ?? ''
                },
                plan: {
                    id: initEspecialidad.plan?.id ?? ''
                }
            })
            setSpecialityDef({value: initEspecialidad.especialty.id, label: initEspecialidad.especialty.name})
        }else{
            setSpecialityDef(null)
            setInitialValues({
                id: null,
                especialty:'',
                duration:'',
                firstWait: '',
                secondWait:'',
                hasCopayment: false,
                amountPayment: '',
                currency: {
                    id: ''
                },
                plan: {
                    id: ''
                }
            })
        }
    }, [initEspecialidad])

    
    
    const timeRegExp = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/g
    const durationRegExp = /^[0-9]{2}:[0-9]{2}$/g
    
    const shemaValidate = Yup.object().shape({
        especialty: Yup.string().required(t('Camporequerido')), 
        duration: Yup.string().required(t('Camporequerido')).matches(durationRegExp, "Debe cumplir con el formato 00:00"),
        firstWait   : Yup.string().required(t('Camporequerido')).matches(timeRegExp, "Debe cumplir con el formato 00:00:00"),
        secondWait   : Yup.string().required(t('Camporequerido')).matches(timeRegExp, "Debe cumplir con el formato 00:00:00"),
        amountPayment: Yup.number().when('hasCopayment', {
            is: true,
            then: Yup.number().required('Campo requerido').min("0", "El campo costo debe ser mayor o igual a cero"),
            otherwise: Yup.number().notRequired()           
        }),
        currency: Yup.object().when('hasCopayment', {
            is: true,
            then: Yup.object().shape({
                id: Yup.string().required('Campo requerido'),
            }),  
            otherwise: Yup.object().shape({
                id: Yup.string().notRequired(),
            })       
        }),
    });
    
    return (
        <Modal show={showModal} onHide={handleClose} size="lg">            
            <Modal.Body>
                <Form.Label className="font-weight-bold mb-2">Nueva especilidad</Form.Label>
                {existeEspecialidad && <div>
                    <Alert variant="danger" className="p-2">No puedes seleccionar la misma especialidad 2 veces.</Alert>
                </div>}
                <Formik
                    initialValues={ initialValues }
                    enableReinitialize
                    validationSchema={ shemaValidate }
                    onSubmit={(values, { setSubmitting, setFieldValue, resetForm }) => { 
                        let obj = Object.assign({}, values)
                        let especialidadObj = specialityOpt.filter(e=>e.value===obj.especialty)
                        obj.especialty = especialidadObj.length > 0 ? {id: especialidadObj[0].value, name: especialidadObj[0].label} : null
                        if(specialtyDurationList.filter(el=>el.especialty.name === obj.especialty.name).length > 0 && indexEdit===null){
                            //error ya existe la especialidad ingresada
                            setExisteEspecialidad(true)
                        }else{
                            if(values.currency?.id){
                                const curr = currenciesOpt.find(item=>item.id === parseInt(values.currency.id))
                                obj.currency = curr;
                            }else{
                                obj.currency = null;
                            }
                            if(values.plan?.id){
                                const plan = planesOpt.find(item=>item.id === parseInt(values.plan.id))
                                obj.plan = plan;
                            }else{
                                obj.plan = null;
                            }
                            console.log(obj)
                            setExisteEspecialidad(false)
                            if(indexEdit===null){
                                let a = [...specialtyDurationList]
                                a.push(obj)
                                setSpecialtyDurationList(a)
                            }else{
                                let a = [...specialtyDurationList]
                                a[indexEdit] = obj
                                setSpecialtyDurationList(a)
                            }
                            resetForm({
                                values: {
                                    id: null,
                                    especialty:'',
                                    duration:'',
                                    firstWait: '',
                                    secondWait:'',
                                }
                            })
                            setSpecialityDef(null)
                            setShowModal(false)
                        }
                    }}
                >{({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    resetForm
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label>Especialidad</Form.Label>
                                    <Select 
                                        className="select-especialista"
                                        defaultValue={ specialityDef }
                                        value={ specialityDef }
                                        options={ specialityOpt }
                                        onChange= {(val) =>{
                                            setSpecialityDef(val)
                                            setFieldValue('especialty', val.value)
                                        }}
                                    />
                                    { errors.especialty && <div className="invalid-feedback d-block">{errors.especialty}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label>Duración</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.duration && 'error'}`}
                                        name="duration"
                                        placeholder="00:00"
                                    />
                                    <Form.Text muted>Formato: HH:MM</Form.Text>
                                    { errors.duration && <div className="invalid-feedback d-block">{errors.duration}</div> }                                    
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label>Tiempo espera 1</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.firstWait && 'error'}`}
                                        name="firstWait"
                                        placeholder="00:00:00"
                                    />
                                    <Form.Text muted>Formato: HH:MM:SS</Form.Text>
                                    { errors.firstWait && <div className="invalid-feedback d-block">{errors.firstWait}</div> } 
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label>Tiempo espera 2</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.secondWait && 'error'}`}
                                        name="secondWait"
                                        placeholder="00:00:00"
                                    />
                                    <Form.Text muted>Formato: HH:MM:SS</Form.Text>
                                    { errors.secondWait && <div className="invalid-feedback d-block">{errors.secondWait}</div> }                                    
                                </Form.Group>
                            </Col>
                            {
                                hasCopaymentParent && 
                                <>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Field 
                                                type="checkbox"
                                                className={`mr-2`}
                                                name="hasCopayment"
                                                placeholder="00:00:00"
                                            />              
                                            <Form.Label>Tiene copago</Form.Label>                                                  
                                        </Form.Group>
                                    </Col>
                                    {
                                        values.hasCopayment &&
                                        <>
                                            <Col xs="12" md="4">
                                                <Form.Group>
                                                    <Form.Label>Tipo plan</Form.Label>
                                                    <Field 
                                                        as="select"
                                                        className={`form-control input-form ${errors.plan?.id && 'error'}`}
                                                        name="plan.id"
                                                    >
                                                        <option value="">Ninguna</option>
                                                        {
                                                            planesOpt.map((item,i)=>(
                                                                <option value={item.id} key={i}>{item.name}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    { errors.plan?.id && <div className="invalid-feedback d-block">{errors.plan?.id}</div> }                                    
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Form.Group>
                                                    <Form.Label>Costo</Form.Label>
                                                    <Field 
                                                        type="number"
                                                        className={`form-control input-form ${errors.amountPayment && 'error'}`}
                                                        name="amountPayment"
                                                    />
                                                    { errors.amountPayment && <div className="invalid-feedback d-block">{errors.amountPayment}</div> }                                    
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <Form.Group>
                                                    <Form.Label>Moneda</Form.Label>
                                                    <Field 
                                                        as="select"
                                                        className={`form-control input-form ${errors.currency?.id && 'error'}`}
                                                        name="currency.id"
                                                    >
                                                        <option value="">{t('Seleccionar')}</option>
                                                        {
                                                            currenciesOpt.map((item,i)=>(
                                                                <option value={item.id} key={i}>{item.code}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    { errors.currency?.id && <div className="invalid-feedback d-block">{errors.currency?.id}</div> }                                    
                                                </Form.Group>
                                            </Col>
                                        </> 
                                    }
                                </>
                            }
                        </Row>
                        <Row>
                            <Col className="text-right">
                                <Button variant="secondary" type="button" onClick={handleClose}>Cancelar</Button>{' '}
                                <Button variant="outline-primary" type="submit">Aceptar</Button>
                            </Col>
                        </Row>
                    </Form>
                )}
                </Formik>
            </Modal.Body>
      </Modal>
    )

}

export default withTranslation()(ComponentNewSpecilidad)